/**
 * テーマ初期化ユーティリティ
 * OSのダークモード設定を検出して、初期テーマを設定する
 */

import { ThemeName, getSystemTheme } from '../styles/colors';

const THEME_STORAGE_KEY = 'marle-library-theme';

/**
 * システムのダークモード設定を検出して初期テーマを設定
 */
export const initializeTheme = (): ThemeName => {
  // localStorageから保存されたテーマを取得
  const savedTheme = localStorage.getItem(THEME_STORAGE_KEY) as ThemeName | null;
  
  if (savedTheme === 'light' || savedTheme === 'dark') {
    // 保存されたテーマがある場合はそれを使用
    setTheme(savedTheme);
    return savedTheme;
  }
  
  // 保存されていない場合はシステム設定を参照
  const systemTheme = getSystemTheme();
  setTheme(systemTheme);
  return systemTheme;
};

/**
 * テーマを設定（DOMとlocalStorageに保存）
 */
export const setTheme = (theme: ThemeName): void => {
  document.documentElement.setAttribute('data-theme', theme);
  localStorage.setItem(THEME_STORAGE_KEY, theme);
};

/**
 * 現在のテーマを取得
 */
export const getCurrentTheme = (): ThemeName => {
  const themeAttr = document.documentElement.getAttribute('data-theme');
  if (themeAttr === 'light' || themeAttr === 'dark') {
    return themeAttr;
  }
  return getSystemTheme();
};

